import { markRaw } from 'vue';
import axios from 'axios';
import lib from '@/lib';

import StationedUnitTooltip from '@/components/tooltips/troops/StationedUnit';
import StationedShipTooltip from '@/components/tooltips/troops/StationedShip';

export default class TroopsModel {
	// после отправки войск время для отмены 1 минута 30 секунд (кроме доставки ресурсов. там не отменить)
	
	constructor() {
		this.show = true;
		
		this.movements = [
			{
				name: 'incoming_attacks',
				movementType: 'attack',
				movementDirection: 'incoming',
				movementIcon: 'movement_attack_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'baryga',
						srcIsland: 'Hersonsk',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((0 * 60) + 34) * 60) + 38), // 00:34:38
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 34) * 60) + 38),
					},
					{
						id: 2,
						srcPlayer: 'baryga',
						srcIsland: 'Achtunsk',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((0 * 60) + 34) * 60) + 37), // 00:34:37
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 34) * 60) + 37),
					},
				],
			},
			{
				name: 'incoming_merchant',
				movementType: 'merchant',
				movementDirection: 'incoming',
				movementIcon: 'movement_trade_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'SVal',
						srcIsland: 'Комендантский',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((1 * 60) + 28) * 60) + 19), // 01:28:19
						timeFinish: (Date.now() / 1000) + ((((1 * 60) + 28) * 60) + 19),
						resources: [0, 0, 0, 300, 0],
					},
				],
			},
			{
				name: 'incoming_merchant_return',
				movementType: 'merchant_return',
				movementDirection: 'incoming',
				movementIcon: 'movement_trade_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'SVal',
						srcIsland: 'Комендантский',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((1 * 60) + 28) * 60) + 19), // 01:28:19
						timeFinish: (Date.now() / 1000) + ((((1 * 60) + 28) * 60) + 19),
						resources: [0, 0, 0, 300, 0],
					},
				],
			},
			{
				name: 'incoming_merchant2',
				movementType: 'merchant2',
				movementDirection: 'incoming',
				movementIcon: 'movement_trade_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'Разбойник',
						srcIsland: 'Логово разбойников',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((0 * 60) + 13) * 60) + 45), // 00:13:45
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 13) * 60) + 45),
						resources: [200, 150, 0, 150, 0],
					},
				],
			},
			{
				name: 'return',
				movementType: 'return',
				movementDirection: 'incoming',
				movementIcon: 'movement_support_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'Разбойник',
						srcIsland: 'Логово разбойников',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((0 * 60) + 5) * 60) + 37), // 00:05:37
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 5) * 60) + 37),
					},
					{
						id: 2,
						srcPlayer: 'lexinzector',
						srcIsland: 'InZectorsk',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((0 * 60) + 9) * 60) + 42), // 00:09:42
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 9) * 60) + 42),
					},
				],
			},
			{
				name: 'return',
				movementType: 'support',
				movementDirection: 'incoming',
				movementIcon: 'movement_support_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'lexinzector',
						srcIsland: 'InZectorsk',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((1 * 60) + 28) * 60) + 19), // 01:28:19
						timeFinish: (Date.now() / 1000) + ((((1 * 60) + 28) * 60) + 19),
					},
				],
			},
			{
				name: 'incoming_defends',
				movementType: 'defend',
				movementDirection: 'incoming',
				movementIcon: 'movement_defend_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'lexinzector',
						srcIsland: 'InZectorsk',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((1 * 60) + 28) * 60) + 19), // 01:28:19
						timeFinish: (Date.now() / 1000) + ((((1 * 60) + 28) * 60) + 19),
					},
				],
			},
			{
				name: 'incoming_heals',
				movementType: 'heal',
				movementDirection: 'incoming',
				movementIcon: 'movement_heal_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'Разбойник',
						srcIsland: 'Логово разбойников',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((23 * 60) + 26) * 60) + 0), // 23:26:00
						timeFinish: (Date.now() / 1000) + ((((23 * 60) + 26) * 60) + 0),
					},
				],
			},
			{
				name: 'incoming_tributes',
				movementType: 'tribute',
				movementDirection: 'incoming',
				movementIcon: 'movement_tribute_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'Разбойник',
						srcIsland: 'Логово разбойников',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((23 * 60) + 26) * 60) + 0), // 23:26:00
						timeFinish: (Date.now() / 1000) + ((((23 * 60) + 26) * 60) + 0),
					},
				],
			},
			{
				name: 'incoming_woundeds',
				movementType: 'wounded',
				movementDirection: 'incoming',
				movementIcon: 'movement_wounded_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'Разбойник',
						srcIsland: 'Логово разбойников I',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((0 * 60) + 13) * 60) + 45), // 00:13:45
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 13) * 60) + 45),
					},
				],
			},
			{
				name: 'outgoung_defends',
				movementType: 'defend',
				movementDirection: 'outgoing',
				movementIcon: 'movement_defend_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'Разбойник',
						srcIsland: 'Логово разбойников',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((0 * 60) + 13) * 60) + 45), // 00:13:45
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 13) * 60) + 45),
					},
				],
			},
			{
				name: 'outgoung_heals',
				movementType: 'heal',
				movementDirection: 'outgoing',
				movementIcon: 'movement_heal_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'Разбойник',
						srcIsland: 'Логово разбойников',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((0 * 60) + 13) * 60) + 45), // 00:13:45
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 13) * 60) + 45),
					},
				],
			},
			{
				name: 'outgoung_tributes',
				movementType: 'tribute',
				movementDirection: 'outgoing',
				movementIcon: 'movement_tribute_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'Разбойник',
						srcIsland: 'Логово разбойников',
						destPlayer: 'lexinzector',
						destIsland: 'Брест',
						time: ((((0 * 60) + 13) * 60) + 45), // 00:13:45
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 13) * 60) + 45),
					},
				],
			},
			{
				name: 'outgoing_adventure',
				movementType: 'adventure',
				movementDirection: 'outgoing',
				movementIcon: 'movement_adventure_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'lexinzector',
						srcIsland: 'Брест',
						destPlayer: '',
						destIsland: '',
						time: ((((0 * 60) + 13) * 60) + 45), // 00:13:45
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 13) * 60) + 45),
					},
				],
			},
			{
				name: 'outgoing_attacks',
				movementType: 'attack',
				movementDirection: 'outgoing',
				movementIcon: 'movement_attack_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'lexinzector',
						srcIsland: 'Брест',
						destPlayer: 'Природа',
						destIsland: 'Оазис (11|-24)',
						time: ((((0 * 60) + 1) * 60) + 20), // 00:01:20
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 1) * 60) + 20),
					},
				],
			},
			{
				name: 'outgoing_attacks',
				movementType: 'raid',
				movementDirection: 'outgoing',
				movementIcon: 'movement_raid_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'lexinzector',
						srcIsland: 'Брест',
						destPlayer: 'Природа',
						destIsland: 'Оазис (11|-24)',
						time: ((((0 * 60) + 1) * 60) + 20), // 00:01:20
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 1) * 60) + 20),
					},
				],
			},
			{
				name: 'outgoing_attacks',
				movementType: 'spy',
				movementDirection: 'outgoing',
				movementIcon: 'movement_spy_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'lexinzector',
						srcIsland: 'Брест',
						destPlayer: 'Разбойник',
						destIsland: 'Логово разбойников',
						time: ((((0 * 60) + 1) * 60) + 20), // 00:01:20
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 1) * 60) + 20),
					},
				],
			},
			{
				name: 'outgoing_attacks',
				movementType: 'support',
				movementDirection: 'outgoing',
				movementIcon: 'movement_support_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'lexinzector',
						srcIsland: 'Брест',
						destPlayer: 'lexinzector',
						destIsland: 'Зарница',
						time: ((((0 * 60) + 1) * 60) + 20), // 00:01:20
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 1) * 60) + 20),
					},
				],
			},
			{
				name: 'outgoing_merchant',
				movementType: 'merchant',
				movementDirection: 'outgoing',
				movementIcon: 'movement_trade_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'lexinzector',
						srcIsland: 'Брест',
						destPlayer: 'SVal',
						destIsland: 'Комендантский',
						time: ((((1 * 60) + 28) * 60) + 19), // 01:28:19
						timeFinish: (Date.now() / 1000) + ((((1 * 60) + 28) * 60) + 19),
						resources: [0, 300, 0, 0, 0],
					},
				],
			},
			{
				name: 'outgoing_settlement',
				movementType: 'settle',
				movementDirection: 'outgoing',
				movementIcon: 'movement_settle_small_flat_black',
				movements: [
					{
						id: 1,
						srcPlayer: 'lexinzector',
						srcIsland: 'Брест',
						destPlayer: '',
						destIsland: '(-12|-19)',
						time: ((((0 * 60) + 25) * 60) + 56), // 00:25:56
						timeFinish: (Date.now() / 1000) + ((((0 * 60) + 25) * 60) + 56),
					},
				],
			},
		];
		
		this.stationed = [
			{
				open: false,
				name: 'Отряды',
				nation: 'gaul',
				icon: 'tribe_gaul_large_illu',
				units: [
					{type: 1, count: 50}, // дубинщик
					{type: 2, count: 50}, // копейщик
					{type: 3, count: 50}, // мечник
					{type: 4, count: 50}, // топорщик
				],
				tooltip: markRaw(StationedUnitTooltip),
			},
			{
				open: false,
				name: 'Корабли',
				nation: 'nature',
				icon: 'tribe_nature_large_illu',
				units: [
					{type: 1, count: 3}, // шлюп
					{type: 2, count: 5}, // баркас
					{type: 3, count: 2}, // галера
					{type: 4, count: 2}, // фрегат
				],
				tooltip: markRaw(StationedShipTooltip),
			},
			/*{
				open: false,
				name: 'Галлы',
				nation: 'gaul',
				icon: 'tribe_gaul_large_illu',
				count: 14,
				units: [
					{type: 0, count: ''},
					{type: 1, count: 6},
					{type: 2, count: 7},
					{type: 3, count: ''},
					{type: 4, count: ''},
					{type: 5, count: ''},
					{type: 6, count: ''},
					{type: 7, count: ''},
					{type: 8, count: ''},
					{type: 9, count: ''},
					{type: 10, count: ''},
				],
			},
			{
				open: false,
				name: 'Римляне',
				nation: 'roman',
				icon: 'tribe_roman_large_illu',
				count: 14,
				units: [
					{type: 0, count: ''},
					{type: 1, count: 6},
					{type: 2, count: 7},
					{type: 3, count: ''},
					{type: 4, count: ''},
					{type: 5, count: ''},
					{type: 6, count: ''},
					{type: 7, count: ''},
					{type: 8, count: ''},
					{type: 9, count: ''},
					{type: 10, count: ''},
				],
			},
			{
				open: false,
				name: 'Тевтонцы',
				nation: 'teuton',
				icon: 'tribe_teuton_large_illu',
				count: 14,
				units: [
					{type: 0, count: ''},
					{type: 1, count: 6},
					{type: 2, count: 7},
					{type: 3, count: ''},
					{type: 4, count: ''},
					{type: 5, count: ''},
					{type: 6, count: ''},
					{type: 7, count: ''},
					{type: 8, count: ''},
					{type: 9, count: ''},
					{type: 10, count: ''},
				],
			},
			{
				open: false,
				name: 'Природа',
				nation: 'nature',
				icon: 'tribe_nature_large_illu',
				count: 14,
				units: [
					{type: 0, count: ''},
					{type: 1, count: 6},
					{type: 2, count: 7},
					{type: 3, count: ''},
					{type: 4, count: ''},
					{type: 5, count: ''},
					{type: 6, count: ''},
					{type: 7, count: ''},
					{type: 8, count: ''},
					{type: 9, count: ''},
					{type: 10, count: ''},
				],
			},
			{
				open: false,
				name: 'Натары',
				nation: 'natar',
				icon: 'tribe_natar_large_illu',
				count: 14,
				units: [
					{type: 0, count: ''},
					{type: 1, count: 6},
					{type: 2, count: 7},
					{type: 3, count: ''},
					{type: 4, count: ''},
					{type: 5, count: ''},
					{type: 6, count: ''},
					{type: 7, count: ''},
					{type: 8, count: ''},
					{type: 9, count: ''},
					{type: 10, count: ''},
				],
			},*/
		];
	}
}
